import React from 'react';
import PropTypes from 'prop-types';
import { StaticFormGroup } from '@bingads-webui-cc-react/layout';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';

import { DisplayVatStatus } from '../../controls';

const { TaxType } = Constants;

/*
  Taxinfo object contains tax fields corresponding only to that specific format, remaining all tax field values will be null/undefined
  If the value is null/undefined/empty, display '(Not set)' localized string, or else just display the value
*/
export const BaseViewTaxForm = ({
  name, label, value, i18n,
  helpPopupTopic, vatStatus,
}) => (
  <StaticFormGroup
    label={label}
    labelColExtraClass={`TaxField_${name}_label`}
    contentColExtraClass={`TaxField_${name}_value`}
    helpPopupTopic={helpPopupTopic}
  >
    <div className={`tax-id-${name}`}>{value ? value.toString() : i18n.getString(_TL_('(Not set)'))}</div>
    {name === TaxType.VatNumber && <DisplayVatStatus i18n={i18n} vatStatus={vatStatus} />}
  </StaticFormGroup>
);

BaseViewTaxForm.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  helpPopupTopic: PropTypes.string,
  vatStatus: PropTypes.number,
};

BaseViewTaxForm.defaultProps = {
  value: null,
  helpPopupTopic: null,
  vatStatus: null,
};
